import { createNgObject } from "./core/ng";

// web worker message listenr.
/* eslint-disable no-restricted-globals */
self.onmessage = async (e) => {
  const { scriptContent, context, type } = e.data;
  const startTime = Date.now();

  try {
    const { ng, logs, testResults, variables, environment, modifiedContext } = createNgObject(
      context,
      type,
    );

    const executionContext = {
      ng,
      console: ng.console,
      Date: Date,
      Math: Math,
      JSON: JSON,
      setTimeout: setTimeout,
      clearTimeout: clearTimeout,
    };

    const AsyncFunction = Object.getPrototypeOf(async function () {}).constructor;

    const func = new AsyncFunction(
      ...Object.keys(executionContext),
      `"use strict";\n${scriptContent}`,
    );

    const result = await func(...Object.values(executionContext));

    const executionTime = Date.now() - startTime;

    self.postMessage({
      success: true,
      result: result,
      executionTime: executionTime,
      logs: logs,
      testResults: testResults,
      variables: Object.fromEntries(variables),
      environment: Object.fromEntries(environment),
      modifiedContext: modifiedContext,
    });
  } catch (error) {
    const executionTime = Date.now() - startTime;

    self.postMessage({
      success: false,
      error: error.message,
      executionTime: executionTime,
      logs: [],
      modifiedContext: context,
    });
  }
};
